/**
 * Interactive Site Map Drawer Plugin (mobile only)
 *
 * Mounts `[data-panel]` into the drawer starting in a collapsed (72 px peek) state.
 * Tap expands to full open; swipe-down snaps back to collapsed — both behaviours are
 * owned by `drawer.js` via the `peek` option passed to `mountElement`.
 *
 * `restorePanel` is registered so the panel node is moved back to its original parent
 * before `drawerContainer.innerHTML` is cleared, preventing the node from being destroyed.
 *
 * When to touch this file:
 *  - Wiring the partial/full Redux subscription (`selectDrawerMode` → `expandToFullSize` /
 *    `collapseToPartial`) when the full-size drawer state is introduced.
 *  - Any new drawer lifecycle hooks (chip changes, view transitions, etc.).
 *  - If `drawerService` API changes (mountElement, onHtmlRemoved, clearHtml).
 */
export const DRAWER_ID = 'native-interactive-site-map-drawer';
const PEEK_HEIGHT = '72px';

export default function createInteractiveSiteMapDrawerPlugin() {
  return {
    name: DRAWER_ID,

    async start(context) {
      const { drawerService } = context.services;
      if (!drawerService) {
        return;
      }

      const panelElement = context.root.querySelector('[data-panel]');
      if (!panelElement) {
        return;
      }

      const originalParent = panelElement.parentElement;

      function restorePanel() {
        if (panelElement.parentElement !== originalParent) {
          originalParent.appendChild(panelElement);
        }
      }

      drawerService.onHtmlRemoved({ name: DRAWER_ID, callback: restorePanel });
      drawerService.mountElement(panelElement, { peek: PEEK_HEIGHT });
    },

    async stop(context) {
      context.services.drawerService?.clearHtml?.();
    },
  };
}
